import { useCurrentTeamMember } from '@/providers/TeamMemberProvider';
import { useCurrentSalesOrder } from '@/providers/SalesOrderProvider';
import { useSalesOrderPL } from '@/hooks/api/1261_sales_order_pl';
import { MotionDiv } from '@/components/element/MotionDiv';
import { Link } from 'react-router-dom';

export const SalesOrderPL = () => {
  const { _w_, _t_ } = useCurrentTeamMember();
  const { _so_ } = useCurrentSalesOrder();
  const { data: salesOrderPL } = useSalesOrderPL({
    identifier: _w_!.identifier,
    team_id: _t_!.id,
    id: _so_!.id,
  });

  if (salesOrderPL == null) return null;

  return (
    <MotionDiv className="card mb-4">
      <div className="card-header">
        <h6 className="mb-0">プロジェクト収支</h6>
      </div>
      <div className="card-body pt-0">
        <div className="table-responsive">
          <table className="table align-items-center">
            <thead>
              <tr>
                <th
                  className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 px-2"
                  style={{ width: 120 }}
                ></th>
                <th className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 px-2 text-end">
                  予定金額（税抜）
                </th>
                <th className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 px-2 text-end">
                  実績金額（税抜）
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="text-xs text-dark">{_so_!.name}</td>
                <td className="text-xs text-dark text-end">¥{salesOrderPL.sales_scheduled_amount.toLocaleString()}</td>
                <td className="text-xs text-dark text-end">¥{salesOrderPL.sales_amount.toLocaleString()}</td>
              </tr>
              {salesOrderPL.related_order_pls.map((d, i) => (
                <tr key={`ropls-${i}`}>
                  <td className="text-xs text-dark">
                    <Link
                      to={`/w/${_w_!.identifier}/teams/${d.purchase_order_team_id}/purchase_orders/${
                        d.purchase_order_id
                      }`}
                      className="d-flex align-items-center justify-content-between"
                    >
                      <u>{d.purchase_order_name}</u>
                    </Link>
                  </td>
                  <td className={`text-xs text-end ${d.scheduled_amount == 0 ? 'text-dark' : 'text-danger'}`}>
                    {d.scheduled_amount == 0 ? '' : '-'}¥{d.scheduled_amount.toLocaleString()}
                  </td>
                  <td className={`text-xs text-end ${d.amount == 0 ? 'text-dark' : 'text-danger'}`}>
                    {d.amount == 0 ? '' : '-'}¥{d.amount.toLocaleString()}
                  </td>
                </tr>
              ))}
              <tr>
                <td className="text-xs font-weight-bold text-dark">収支合計</td>
                <td
                  className={`text-xs font-weight-bold ${
                    salesOrderPL.scheduled_pl < 0 ? 'text-danger' : 'text-dark'
                  } text-end`}
                >
                  {salesOrderPL.scheduled_pl < 0 ? '-' : ''}¥{Math.abs(salesOrderPL.scheduled_pl).toLocaleString()}
                </td>
                <td
                  className={`text-xs font-weight-bold ${salesOrderPL.pl < 0 ? 'text-danger' : 'text-dark'} text-end`}
                >
                  {salesOrderPL.pl < 0 ? `-` : ''}¥{Math.abs(salesOrderPL.pl).toLocaleString()}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </MotionDiv>
  );
};
